<template>
   <div>
      <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(2215,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
         Search gene
      </p>
      <el-tabs v-model="activeOmics" type="border-card" style="width:50%;display: inline-block;height:400px;font-size:17px" @tab-click="handleClick">
         <el-tab-pane style="height:350px;" label="By gene ID" name="gene_id">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="geneIdText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_gene_id.txt" download="example_gene_id.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
                  <!-- <div class="el-upload__tip" slot="tip">Only txt files can be uploaded, and not more than 500kb</div> -->
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               margin-top: 15px;
               height:65px;
               margin-left: auto;
               margin-right: auto;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 15px;">
                  The gene ID here means entrez ID. Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
            
            </el-card> 
         </el-tab-pane>

         <el-tab-pane style="height:350px" label="By gene name" name="gene_name">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="geneNameText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_gene_name(gene).txt" download="example_gene_name.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
                  <!-- <div class="el-upload__tip" slot="tip">Only txt files can be uploaded, and not more than 500kb</div> -->
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               height:66px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 14px;">
               <div>
                  The gene name here means gene symbol from HGNC database. Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
               </div>
            
            </el-card> 
         </el-tab-pane>

         <el-tab-pane style="height:350px" label="By location" name="gene_location">
            Choose chromosome:
            <el-select v-model="activeChromosome" placeholder="请选择" style="margin-top: 30px;width:53%;">
               <el-option
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
               </el-option>
            </el-select>
            <br>
            Enter position range<a href="javascript:void(0)" @click="fillText">(example)</a>:
               <el-input
                  style="width:120px;margin-top: 35px; "
                  :rows="1"
                  placeholder="start"
                  v-model="startText"
                  resize=none
                  clearable>
               </el-input>
               <span> - </span>
               <el-input
                  style="width:120px;margin-top: 35px; "
                  :rows="1"
                  placeholder="end"
                  v-model="endText"
                  resize=none
                  clearable>
               </el-input>
               <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 15px;margin-top: 35px;">Submit</el-button>   
               <el-card style="width:95%;
                        height:70px;
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 25px;
                        background-color: rgba(255,208,75,0.05);
                        color: rgb(250,170,0);
                        font-size: 17px;">
                  The gene locatoins here are from HGNC database. All genes within the input position range will be searched.
            
            </el-card>       
         </el-tab-pane>

         <el-tab-pane style="height:350px" label="By disease CUI" name="disease_cui">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="diseaseCuiText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_disease_cui.txt" download="example_disease_cui.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
                  <!-- <div class="el-upload__tip" slot="tip">Only txt files can be uploaded, and not more than 500kb</div> -->
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               height:65px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 14px;">
               <div>
                  The disease CUI here means disease ID from MedGen database. Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
               </div>
            </el-card>       
         </el-tab-pane>
      </el-tabs>
      <div style="width:49%;height:400px;margin-left:0;display: inline-block;vertical-align: top">
         <PiechartVue ref="gene_pie" style="width:550px;height:50%;margin:auto"/>
         <BarchartVue ref="gene_bar" :barData="barData" :barTitle="barTitle" style="width:550px;height:50%;margin:auto"/>
      </div>
    
      <el-card class="box-card">
         <el-table ref="geneTable" id="table" :data="tableData" style="width: auto" height=630px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
            <el-table-column prop="gene_id" label="Gene ID" sortable="true" width="100" fixed></el-table-column>
            <el-table-column prop="gene_name" label="Gene name" sortable="true" width="120" fixed></el-table-column>
            <el-table-column v-for='(item,key) in geneFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">  
               <template v-if="item.key === 'pmid'" v-slot="scope">
                  <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                  </template>
               </el-table-column>
         </el-table>
         <el-pagination
            @size-change="(val) => handleSizeChange(val)"
            @current-change="(val) => handleCurrentChange(val)"
            :current-page="currentPage"
            :page-sizes="[10,20,30]"
            :page-size="10"
            layout="->,total, sizes, prev, pager, next, jumper"
            :total= this.totalCount
            style="margin-left:auto;">
         </el-pagination>
         <div style="text-align:left;margin:1%;line-height: 25px;">
            *Score_dgn: The GDA score from DisGENET, scoreing the gene-disease association according to its evidence level.<br/>
            *Disease-CUI: The disease phenotype and its concept ID from UMLS the gene associated with when collected from DisGENET.<br/>
            *Source: The database where the gene was collected. 'manual retrieval' means retrieved manually from literature.
         </div>
      </el-card>
   </div>
</template>
<script>
import qs from 'qs'
import{Loading}from'element-ui';
import BarchartVue from '../../chart/Barchart.vue';
import PiechartVue from '../../chart/Piechart.vue'
   export default {
      data() {
         return {
            inputFlag:false,
            //table
            tableData:[],
            geneFields: [
                { key: "source", label: "source", sortable: true,width:110},
                { key: "pmid", label: "PMID", sortable: true,minWidth:370},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,width:130},
                { key: "score_dgn", label: "Score_dgn", sortable: true,width:120},
                { key: "map_location", label: "Map location", sortable: true,width:130},
                { key: "chromosome", label: "Chromosome", sortable: true,width:135},
                { key: "start", label: "Start",sortable: true,width:100},
                { key: "end", label: "End", sortable: true,width:100},
                { key: "disease", label: "Disease", sortable: true,width:120},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,width:130},
                
            ],
            currentPage:1,
            totalCount:0,
            pageSize:10,
            desc:null,
            sortby:null,
            //active
            activeOmics: 'gene_id',
            activeChromosome:'1',
            // enter list
            geneIdText: '',
            geneNameText:'',
            diseaseCuiText:'',
            startText:'',
            endText:'',
            uploadFiles: [],
            enterList:[],
            options: [{                
                value: '1',
                label: '1'
                },{
                value: '2',
                label: '2'
                },{
                value: '3',
                label: '3'
                },{
                value: '4',
                label: '4'
                },{
                value: '5',
                label: '5'
                },{
                value: '6',
                label: '6'
                },{
                value: '7',
                label: '7'
                },{
                value: '8',
                label: '8'
                },{
                value: '9',
                label: '9'
                },{
                value: '10',
                label: '10'
                },{
                value: '11',
                label: '11'
                },{
                value: '12',
                label: '12'
                },{
                value: '13',
                label: '13'
                },{
                value: '14',
                label: '14'
                },{
                value: '15',
                label: '15'
                },{
                value: '16',
                label: '16'
                },{
                value: '17',
                label: '17'
                },{
                value: '18',
                label: '18'
                },{
                value: '19',
                label: '19'
                },{
                value: '20',
                label: '20'
                },{
                value: '21',
                label: '21'
                },{
                value: '22',
                label: '22'
                },{
                value: 'X',
                label: 'X'
                },{
                value: 'Y',
                label: 'Y'
            }],
            pieData: [{
                    value: 795,
                    name: "Anxiety disorder"
                },{
                    value: 6837,
                    name: "Bipolar disorder"
                },{
                    value: 1396,
                    name: "Major depressive disorder"
                },{
                    value: 11478,
                    name: "Schizophrenia"
            }],
            pieTitle:"Disease composition of gene data",
            barData: [{
                    value: 5765,
                    name: "DisGeNET v7.0"
                },{
                    value: 6246,
                    name: "dbBIP"
                },{
                    value: 10336,
                    name: "SZDB2.0"
                },{
                    value: 1323,
                    name: "SZGR2.0"
               },{
                  value:245,
                  name:"manual retrieval"
               }],
            barTitle:"Source composition of gene data",
         };
      },
      methods: {
         handleClick(tab, event) {
            this.uploadFiles = []
            this.enterList = []
         },
         getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#table')
            });
            if(this.activeOmics=='gene_location'){
               this.axios.get(this.GLOBAL.rootAddress+'search/gene/gene_location',{
               params: { 
                  'pageNum': this.currentPage,
                  'pageSize': this.pageSize,
                  'sortBy':this.sortby,
                  'desc':this.desc,
                  'chromosome':this.activeChromosome,
                  'start':this.startText,
                  'end':this.endText
                  },
               })
               .then(response=> {
                  loadingInstance.close();  
                  this.totalCount=response.data.data.total;
                  this.tableData=response.data.data.records;
                  if(this.tableData.length==0){
                     this.$message.error('Sorry, no results found. Try different keywords.');
                  }
               })
               .catch(error=> {
                  loadingInstance.close();  
                  console.log(error);
               });
               return;
            }
            this.axios.get(this.GLOBAL.rootAddress+'search/gene/'+this.activeOmics,{
               params: { 
                  'pageNum': this.currentPage,
                  'pageSize': this.pageSize,
                  'sortBy':this.sortby,
                  'desc':this.desc,
                  'searchArray':this.enterList+''
               },
            })
            .then(response=> {
               console.log(this.tableData)
               loadingInstance.close(); 
               this.totalCount=response.data.data.total;
               this.tableData=response.data.data.records;
               if(this.tableData.length==0){
                  this.$message.error('Sorry, no results found. Try different keywords.');
               }
            })
            .catch(error=> {
               loadingInstance.close();
               console.log(error);
            });
         },
        //table
         handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
         },
         handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
         },
         sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=0
            }
            this.getData()
         },
         //upload
         handleExceed(){
            this.$message.error('Only one file can be uploaded.');
         },
         handleRemove(file){
            this.uploadFiles=[]
         },
         handleChange(file, fileList){
            if (file.name.split('.').pop() !== 'txt'&& file.name.split('.').pop() !== 'TXT') { // 类型有可能大写
               fileList = []
               this.uploadFiles = []
               this.$message.error('Please up load file in txt format')
            }else if(file.size/1024>500){
               fileList = []
               this.uploadFiles = []
               this.$message.error('Please up load file no more than 500kb')
            }else{
               this.uploadFiles = fileList
            }
         },
         fillText(){
            switch(this.activeOmics){
               case 'gene_id':
                  this.geneIdText='9863\n3356\n85358\n4842\n1463\n8831\n6671\n5428\n1392\n348\n2908\n4524\n6532\n6532\n84062\n4729\n23621\n134864\n4135\n5609\n6529\n2571\n1816\n6616\n6869\n7546\n';
                  return ;
               case 'gene_name':
                  this.geneNameText='CB1A\nCD143\nBCL9\nSLC25A4\nHLA-B\nDCC\nNKAPL\nPGBD1\nPBRM1\nPPP2R2B\nZKSCAN4\nCSMD1\nTSPAN8\nPDE10A\nBCL11A\nNFIX'
                  return;
                  case 'gene_location':
                  this.startText=173488230;
                  this.endText=293647521;
                  return;
               case 'disease_cui':
                  this.diseaseCuiText='C0036341\nC0041696\nC0853193\nC1269683'
                  return;
            }
           
         },
         submit() {
            if (this.$refs.geneTable){
               this.$refs.geneTable.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10

            if(this.activeOmics=="gene_location"){
               this.getData()
               return;
            }
            var textarea="";
            switch(this.activeOmics){
               case 'gene_id':
                  textarea=this.geneIdText;
                  break;
               case 'gene_name':
                  textarea=this.geneNameText;
                  break;
               case 'disease_cui':
                  textarea=this.diseaseCuiText;
                  break;
            }
            if(this.uploadFiles.length){
               let file = this.uploadFiles[0]
               let reader = new FileReader()
               reader.readAsText(file.raw)
               reader.onload = (e) => {
                  console.log(e.target.result)
                  this.enterList=e.target.result.split(/[\r\n]+/)
                  //preprocess the data
                  this.enterList = this.enterList.filter((s) => {return s && s.trim(); });
                  this.enterList=this.enterList.map(function (item) {
                     return(item.trim())
                  });
                  this.enterList = Array.from(new Set(this.enterList));
                  //warning
                  if(this.enterList.length>200){
                     this.$message.error('The input cannot exceed 200 entries.');
                  }else if(this.enterList.length==0){
                     this.$message.error('Please enter your list or upload a file!');
                  }else {
                     this.getData()
                     this.$message.success('You submitted the list in the file successfully.')
                  }
               }
            }else if(textarea){        
               this.enterList=textarea.split(/[\r\n]+/)
               //preprocess the data
               this.enterList = this.enterList.filter((s) => {return s && s.trim();});
               this.enterList=this.enterList.map(function (item) {
                     return(item.trim())
                  });
               this.enterList = Array.from(new Set(this.enterList));
               //warning
               if(this.enterList.length>200){
                  this.$message.error('The input cannot exceed 200 entries.');
               }else if(this.enterList.length==0){
                  this.$message.error('Please enter your list or upload a file!');
               }else {
                  this.getData()
                  this.$message.success('You submitted the list in the textarea successfully.')
               }
            }else this.$message.error('Please enter your list or upload a file!');   
         }
      },
      mounted () {
       this.$refs.gene_pie.initData(this.pieData,this.pieTitle)
       this.$refs.gene_pie.initChart()
      },
      components:{
         BarchartVue,
         PiechartVue
      }
   };
</script>

<style>
   .el-upload-dragger{
      height:120px !important;
      margin-left:5% !important;
      margin-right:5% !important;
      margin-top: 0;
      width:90% !important;
      
   }
   .el-icon-upload{
      margin: 10px 0 0px !important;
    }
    .el-card__body{
      padding:15px !important;
    }
    .el-upload-list__item:first-child{
      margin-top: 0 !important;
    }
</style>
